import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const mealPlanService={
    addFirstInitialStage,
    getFoodItems,
    submitDailyMealPlan,
    sendForApproval
}

function addFirstInitialStage(request){
    return apiCall("POST",apiUrls.food.mealPlan,request)
}
function getFoodItems(params){
    return apiCall("GET",apiUrls.food.library,null,params)  
}

function submitDailyMealPlan(request,id){

    return apiCall("PUT",`${apiUrls.food.mealPlan}/${id}/roster`,request)
}

function sendForApproval(id){
    return apiCall("POST",`${apiUrls.food.mealPlan}/${id}/submit`)
}
// function updateFoodLibrary(request,id){

//     return apiCall("PUT",`${apiUrls.food.library}/${id}`,request)
// }

// function getAllFoodItems(params){

//     return apiCall("GET",apiUrls.food.library,null,params)
// }